import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-arrow-down',
  standalone: true,
  template: `
    <svg
      width="15"
      height="15"
      viewBox="0 -5 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [attr.class]="className"
    >
      <path
        d="M25.138 9.76275C24.8098 9.43468 24.3648 9.25037 23.9008 9.25037C23.4367 9.25037 22.9917 9.43467 22.6635 9.76275L14.001 18.4252L5.33852 9.76275C5.00846 9.44397 4.56641 9.26758 4.10756 9.27157C3.64872 9.27556 3.2098 9.4596 2.88533 9.78407C2.56087 10.1085 2.37682 10.5475 2.37284 11.0063C2.36885 11.4651 2.54524 11.9072 2.86401 12.2372L12.7638 22.137C13.0919 22.4651 13.537 22.6494 14.001 22.6494C14.4651 22.6494 14.9101 22.4651 15.2383 22.137L25.138 12.2372C25.4661 11.9091 25.6504 11.464 25.6504 11C25.6504 10.536 25.4661 10.0909 25.138 9.76275Z"
        [attr.fill]="fill || 'black'"
        [attr.stroke]="stroke || ''"
      />
    </svg>
  `
})
export class ArrowDownComponent {
  @Input() fill?: string;
  @Input() className?: string;
  @Input() stroke?: string;
}
